import { useState, useEffect } from "react";

const COMPACT_BREAKPOINT = 1500;

export function useIsCompactView() {
  const [isCompact, setIsCompact] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${COMPACT_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsCompact(window.innerWidth < COMPACT_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsCompact(window.innerWidth < COMPACT_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isCompact;
}
